import { useQuery } from '@tanstack/react-query';

import { ResolvedPortalConfig, resolvePortalConfig } from '../registry/resolvePortalConfig';
import { getPortalConfig } from '../services/reportService';

export interface UsePortalConfigResult extends ResolvedPortalConfig {
  isLoading: boolean;
}

export const usePortalConfig = (): UsePortalConfigResult => {
  const { data, isLoading } = useQuery({
    queryKey: ['portal-config'],
    queryFn: getPortalConfig,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
  return { ...resolvePortalConfig(data), isLoading };
};
